// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Guide explaining the meaning of different amendment formatting types.
 */
import type { FC } from 'react'

export const AmendmentTypeGuide: FC = () => {
  return (
    <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <h4 className="font-medium text-blue-800 mb-3">Amendment Type Guide</h4>
      <div className="space-y-2 text-sm text-blue-700">
        <div className="flex items-start gap-2">
          <span className="underline text-green-600 font-medium shrink-0">Underline:</span>
          <span>indicates amendments to bill</span>
        </div>
        <div className="flex items-start gap-2">
          <span className="line-through text-red-600 font-medium shrink-0">Strike:</span>
          <span>indicates matter stricken from the bill by amendment or deleted from the law by amendment</span>
        </div>
        <div className="flex items-start gap-2">
          <span className="italic text-orange-600 font-medium shrink-0">Italics:</span>
          <span>indicate opposite chamber/conference committee amendments</span>
        </div>
        <div className="mt-3 pt-2 border-t border-blue-200">
          <span className="font-medium">Note:</span> Multiple formatting types can apply to the same text
        </div>
      </div>
    </div>
  )
}
